import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'estadisticas'

const Estadisticas = {
  estadisticasTipoTrabajo(idGrupoExplotacionList, idTemporada, idCultivo) {
    let data = {
      idGrupoExplotacionList,
      idTemporada,
      idCultivo
    }
    return ApiService.get(`${REPOSITORY_URL}/estadisticas_tipo_trabajo`, data)
  },

  estadisticasRubro(idGrupoExplotacionList, idTemporada, idCultivo) {
    let data = {
      idGrupoExplotacionList,
      idTemporada,
      idCultivo
    }
    return ApiService.get(`${REPOSITORY_URL}/estadisticas_rubro`, data)
  },

  estadisticasTipoTrabajoAgricultor(idEstablecimiento, idGrupoExplotacion, idTemporada) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      idTemporada,
    }
    return ApiService.get(`${REPOSITORY_URL}/estadisticas_tipo_trabajo_agricultor`, data)
  },

  // Estadisticas para creas ganaderas
  estadisticasProduccionAnimal(idGrupoExplotacionList, idTemporada){
    const data = {
      idGrupoExplotacionList,
      idTemporada
    }
    return ApiService.get(`${REPOSITORY_URL}/estadisticas_produccion_animal`, data)
  }
}

export default Estadisticas
